import { PlayCircleOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import { cloneDeep, get } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../components/functional_components/Button/PFButton";
import DetailBox from "../../../components/functional_components/DetailBox/DetailBox";
import InvokeJob from "../../../services/api/InvokeJob";
import { showError, showSuccess } from "../../../utils/utilities";
import "./jobs.css";

const Jobs = () => {
  const { t } = useTranslation();
  const [allJobs, setJobs] = useState([]);

  useEffect(() => {
    getExecutableJobs();
  }, []);

  const getExecutableJobs = async () => {
    const jobsList = await InvokeJob.getJobsList();
    if (!jobsList.error && jobsList.data) {
      setJobs(jobsList.data);
    } else {
      showError(get(jobsList, "error.messageCode", "ER000"));
    }
  };

  const updateIsLoading = (isLoading, apiEndpoint) => {
    let allJobsClone = cloneDeep(allJobs);
    allJobsClone.forEach((job) => {
      if (job.apiEndpoint === apiEndpoint) {
        job.isLoading = isLoading;
      }
    });
    setJobs(allJobsClone);
  };

  const executeSelectedJob = (apiEndpoint) => async () => {
    updateIsLoading(true, apiEndpoint);
    // substr() because the endPoint received is like /invoke-job/import-orders and I already have the "/"
    const executed = await InvokeJob.executeJob(apiEndpoint.substr(1));
    if (!executed.error) {
      showSuccess(executed);
    } else {
      showError(get(executed, "error.messageCode", "ER000"));
    }
    updateIsLoading(false, apiEndpoint);
  };
  return (
    <>
      <DetailBox title={t("jobs.jobsTitle")}>
        <Row justify="space-between">
          {allJobs.map((job) => {
            return (
              <Col lg={8} key={job.label} className="width-100 mb-2em">
                <Row align="middle" justify="space-between" className="job-block">
                  <Col span={20} className="fw-bold">
                    {t(`jobs.${job.label}`)}
                  </Col>
                  <Col span={4} style={{ paddingLeft: "5px" }}>
                    <Button
                      currentIcon={<PlayCircleOutlined className="icon-large" />}
                      clickCallback={executeSelectedJob(job.apiEndpoint)}
                      currentSize="large"
                      isLoading={job.isLoading}
                    />
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </DetailBox>
    </>
  );
};

export default Jobs;
